import {mapGetters} from "vuex";

export default {
    created() {
        this.$store.dispatch('getStatuses');
    },
    computed: {
        ...mapGetters([
            'statusListForJobPost'
        ])
    },
    watch: {
        statusListForJobPost: {
            handler: function (data) {
                let filter = this.options.filters.find(item => item.key === 'status');
                filter.option = data;
                if (data.length > 0) {

                    filter.active = data.find(i => i.name === 'status_open').id;
                }
            }
        }
    }
}